import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

function initializeWidget(mountPointId, shadowRoot, baseUrl) {
    window.__DOUG_WIDGET_BASE_URL__ = baseUrl;
    
    const mountPoint = shadowRoot.getElementById(mountPointId);
    if (mountPoint) {
        console.log('Mount point found, creating widget...');
        const widgetRoot = ReactDOM.createRoot(mountPoint);
        widgetRoot.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    } else {
        console.error('Widget mount point not found in Shadow DOM');
    }
}

// Standalone initialization function
function initializeStandalone() {
    const rootElement = document.getElementById('root');
    if (rootElement) {
        const root = ReactDOM.createRoot(rootElement);
        root.render(
            <React.StrictMode>
                <App />
            </React.StrictMode>
        );
    }
}

// Make the initialize function available globally
window.initializeWidget = initializeWidget;

// Only initialize standalone if NOT in widget mode
if (!window.__DOUG_WIDGET_MODE__ && document.getElementById('root')) {
    initializeStandalone();
}